<template>
  <chart-line :chart-data="chartData" :chart-options="chartOptions"></chart-line>
</template>

<script lang="js">
import { Bar } from 'vue-chartjs/legacy'
import { COLORS } from './CustomerChart'

const CURRENCY_FORMAT = {
  style: 'currency',
  currency: 'CHF',
  locale: 'de-CH'
}

const LANGUAGE_COLORS = {
  'de_CH': COLORS[0],
  'fr_CH': COLORS[1],
  'it_CH': COLORS[2]
}

const formatCurrency = (value) => {
  return new Intl.NumberFormat(CURRENCY_FORMAT.locale, {
    style: CURRENCY_FORMAT.style,
    currency: CURRENCY_FORMAT.currency
  }).format(value)
}

export default {
  name: 'stacked-year-month-chart',

  components: {
    'chart-line': Bar
  },

  props: {
    data: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && typeof value === 'object'
      }
    }
  },

  computed: {
    chartOptions() {
      return {
        responsive: true,
        aspectRatio: 3/2,
        scales: {
          x: {
            stacked: true,
          },
          y: {
            ticks: {
              callback: (_value, _index, _ticks) => formatCurrency(_value)
            }
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                return `${formatCurrency(context.parsed.y)} (${context.dataset.language})`
              }
            }
          }
        }
      }
    },

    chartData() {
      const datasets = Object.entries(this.data).map(([_, dataset]) => ({
        ...dataset,
        backgroundColor: LANGUAGE_COLORS[dataset.language],
        stack: 'stack1' // Add same stack value for all datasets to enable stacking
      }))

      return {
        datasets,
        labels: []
      }
    }
  }
}
</script>

